module.exports = "<div class=\"padding-5 cursor-pointer header-action-left header-action\" ng-click=\"go('^')\">\n    <h6 class=\"theme whitespace-nowrap\">\n        <!--div class=\"fa fa-angle-left\"></div-->\n        <span class=\"pipe-right\">BACK</span>\n    </h6>\n</div>\n<h6 class=\"flex-stretch padding-5\">News</h6>\n"


//////////////////
// WEBPACK FOOTER
// ./src/apps/news/views/shared/header-article.html
// module id = 408
// module chunks = 22